import { fieldMode, fieldType, fieldsGroupType, validationTypes } from 'components/FormCreatorComponent/types';
import { PurposeCodePickerFormField } from 'components/PurposeCodePicker';

// Snake case validation regex (matches backend validation)
const SNAKE_CASE_REGEX = /^[a-z][a-z0-9]*(_[a-z0-9]+)*$/;

export const paymentCategoryForm = {
	name: 'page.payment_categories.form',
	fieldsGroups: [
		// Basic Info
		{
			type: fieldsGroupType.col,
			fields: [
				{
					type: fieldType.text,
					mode: fieldMode.write,
					props: {
						name: 'name',
						label: 'page.payment_categories.field.name',
						required: true,
						disabled: false,
						placeholder: 'english_snake_case',
					},
					validation: [
						{ requierd: true },
						{
							[validationTypes.custom]: {
								function: (value: string) => !value || SNAKE_CASE_REGEX.test(value),
								errorText: 'validations.errors.snakeCase',
							},
						},
					],
				},
				{
					type: fieldType.select,
					mode: fieldMode.write,
					props: {
						name: 'parentId',
						label: 'page.payment_categories.field.parent_category',
						required: false,
						disabled: false,
						options: [],
					},
				},
				{
					type: fieldType.text,
					mode: fieldMode.write,
					props: {
						name: 'description',
						label: 'page.payment_categories.field.description',
						required: false,
						disabled: false,
					},
				},
			],
		},
		// Name Translations
		{
			type: fieldsGroupType.col,
			fields: [
				{
					type: fieldType.text,
					mode: fieldMode.write,
					props: {
						name: 'nameEn',
						label: 'page.payment_categories.field.name_en',
						required: true,
						disabled: false,
					},
					validation: [{ requierd: true }, { latinLettersSpecialChars: true }],
				},
				{
					type: fieldType.text,
					mode: fieldMode.write,
					props: {
						name: 'nameHe',
						label: 'page.payment_categories.field.name_he',
						required: true,
						disabled: false,
					},
					validation: [{ requierd: true }],
				},
			],
		},
		// Purpose Codes (custom multi-select)
		{
			type: fieldsGroupType.col,
			fields: [
				{
					type: fieldType.custom,
					mode: fieldMode.write,
					props: {
						name: 'paymentPurposeCodeIds',
						label: '',
						customComponent: PurposeCodePickerFormField,
						customData: {}, // populated dynamically in UpsertPaymentCategory
					},
				},
			],
		},
		// Disclaimer Translations
		{
			type: fieldsGroupType.col,
			fields: [
				{
					type: fieldType.textArea,
					mode: fieldMode.write,
					props: {
						name: 'disclaimerEn',
						label: 'page.payment_categories.field.disclaimer_en',
						required: false,
						disabled: false,
						multiline: true,
						rows: 3,
					},
					validation: [{ latinLettersSpecialChars: true }],
				},
				{
					type: fieldType.textArea,
					mode: fieldMode.write,
					props: {
						name: 'disclaimerHe',
						label: 'page.payment_categories.field.disclaimer_he',
						required: false,
						disabled: false,
						multiline: true,
						rows: 3,
					},
				},
			],
		},
		// Active Toggle
		{
			type: fieldsGroupType.row,
			fields: [
				{
					type: fieldType.radio,
					mode: fieldMode.write,
					props: {
						name: 'isActive',
						label: 'label.active',
						options: [
							{ value: '1', label: 'label.yes', disabled: false },
							{ value: '0', label: 'label.no', disabled: false },
						],
						required: true,
						disabled: false,
					},
				},
			],
		},
	],
};
